module.exports = __webpack_public_path__ + "img/1-210P6115625C7.b23fe4fb.png";